export const main_data =
{
  "datamain": [
    {
      'ID': 1,
      'StationCode': '460005',
      'StationName': 'Запорожье-Левое',
      'StationNameLong': 'Запорожье-Левое',
      'CodeEcp': '1',
      'TypeExport': 0,
      'RailwayId': 1,
      'TypePort': 3,
      'StationNameEn': 'Zaporizhzhya-Live',
      'PrizDel': 0,
      'Lat': 47.869721759813046,
      'Lng': 37.552172249841362
    },
    {
      'ID': 2,
      'StationCode': '485604',
      'StationName': 'Мариуполь-Сортировочный',
      'StationNameLong': 'Мариуполь-Сортировочный',
      'CodeEcp': '2',
      'TypeExport': 1,
      'RailwayId': 1,
      'TypePort': 4,
      'StationNameEn': 'Mariupol',
      'PrizDel': 0,
      'Lat': 47.210262951368009,
      'Lng': 37.552172249841362
    },
    {
      'ID': 3,
      'StationCode': '12345',
      'StationName': 'Днепр',
      'StationNameLong': 'Днепр',
      'CodeEcp': '5',
      'TypeExport': 1,
      'RailwayId': 7,
      'TypePort': 5,
      'StationNameEn': 'Dnepr',
      'PrizDel': 0,
      'Lat': 48.38166334758364,
      'Lng': 34.948718602147494
    },
  ],
  
  "is_error": 0,
  "error_text": "Ошибка при получении данных ",
  "user_message_text": ""
}
export const main_data_row_empty =
{
      'ID': null,
      'StationCode': '',
      'StationName': '',
      'StationNameLong': '',
      'CodeEcp': '',
      'TypeExport': null,
      'RailwayId': null,
      'TypePort': null,
      'StationNameEn': '',
      'PrizDel': null,
      'Lat': null,
      'Lng': null
}

export const main_data_empty =
{
  "datamain": [
  ],

  "is_error": 1,
  "error_text": "Ошибка при обращении к методу сервера",
  "user_message_text": ""

}

